import './enhanced-text-input.scss'

import { set } from 'lodash';
import { defineComponent } from 'vue';

import { faBarcode, faEraser } from '@fortawesome/free-solid-svg-icons';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const EnhancedTextInput = defineComponent({
    mixins: [reactiveVueMixin],
    props: ['defaultValue', 'form', 'name', 'autoUpdate', 'getFieldStatus', 'dataCy', 'readOnly'],
    template: require('./enhanced-text-input.html'),
    data() {
        return {
            scanIcon: faBarcode,
            clearIcon: faEraser,
        }
    },
    mounted() {
        this.setFieldValue(this.defaultValue);

        this.$on('field-value-changed', (message) =>
            this.$parent?.$emit('field-value-changed', message)
        )
    },
    methods: {
        eraseInput() {
            this.setFieldValue("");
        },
        setFieldValue(value: string) {
            set(this.form.getState().values, this.name, value)
            this.form.mutators.setFieldTouched(this.name);
        },
        isDisabled() {
            if(this.getFieldStatus) {
                const fieldStatus = this.getFieldStatus(this.name)
                if(fieldStatus) {
                    return fieldStatus.disabled
                }
            }

            return false
        },
    },
})
